import { mergeAttributes, Node } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';

import {
    createFilingSourceCitationAttributes,
    filingSourceCitationContent,
} from '../FilingSourceCitation/attributes';
import { FilingSourceCitationComponent } from '../FilingSourceCitation/component';

export const FilingSourceCitationBlock = Node.create({
    name: 'filingSourceCitationBlock',
    group: 'block',
    atom: true,
    draggable: false,
    isolating: true,
    selectable: false,

    addAttributes() {
        return createFilingSourceCitationAttributes();
    },

    parseHTML() {
        return [
            {
                tag: 'p',
                priority: 1100,
                getAttrs: (element) =>
                    element.classList.contains('filing-source-citation') ||
                    (element.closest('blockquote.filing-source-quote') &&
                        element.querySelector('a.filing-source-button'))
                        ? {}
                        : false,
            },
        ];
    },

    renderHTML({ HTMLAttributes, node }) {
        const company = String(node.attrs.company || 'SEC Filing');
        const filing = String(node.attrs.filing || 'Filing');

        return [
            'p',
            {
                class: 'filing-source-citation',
                contenteditable: 'false',
                'data-filing-source-citation': 'true',
            },
            [
                'a',
                mergeAttributes(HTMLAttributes, { class: 'filing-source-button', 'data-filing-source': 'true' }),
                ...filingSourceCitationContent(company, filing),
            ],
        ];
    },

    addNodeView() {
        return ReactNodeViewRenderer((props) => <FilingSourceCitationComponent {...props} block />);
    },
});
